import { NgModule } from '@angular/core';
import { MatchListComponent } from './match-list.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { TieMatchScoreboardModule } from '../../ties/tie-details/tie-match-list/tie-match-scoreboard/tie-match-scoreboard.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TieMatchScoreboardModule,
        EmptyPageModule
    ],
    declarations: [
        MatchListComponent
    ],
    exports: [
        MatchListComponent
    ]
})
export class MatchListModule { }
